/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ScheduleExecutionParameterForAssessmentAgentAgenticFeed extends models.ScheduleExecutionParameterBase {
    constructor() {
        super();
        this.setDiscriminator("ScheduleExecutionParameterForAssessmentAgentAgenticFeed");
    }

    getFixupPrototypeFunction() { return ScheduleExecutionParameterForAssessmentAgentAgenticFeed.fixupPrototype; }

    static newInstance(model: Partial<ScheduleExecutionParameterForAssessmentAgentAgenticFeed>): ScheduleExecutionParameterForAssessmentAgentAgenticFeed {
        let obj = Object.assign(new ScheduleExecutionParameterForAssessmentAgentAgenticFeed(), model);
        ScheduleExecutionParameterForAssessmentAgentAgenticFeed.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ScheduleExecutionParameterForAssessmentAgentAgenticFeed>): ScheduleExecutionParameterForAssessmentAgentAgenticFeed {
        if (!model) return null;
        return ScheduleExecutionParameterForAssessmentAgentAgenticFeed.newInstance(<ScheduleExecutionParameterForAssessmentAgentAgenticFeed> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ScheduleExecutionParameterForAssessmentAgentAgenticFeed) {
        if (!obj) return;

        models.ScheduleExecutionParameterForAssessmentAgentAgenticFeed.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ScheduleExecutionParameterForAssessmentAgentAgenticFeed): boolean {
        if (models.ScheduleExecutionParameterBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ScheduleExecutionParameterForAssessmentAgentAgenticFeed.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            models.BaseReportConfigurationForAssessmentAgent.fixupPrototype(this.configuration);
        }
    }

    configuration: models.BaseReportConfigurationForAssessmentAgent;

    /**
     * AI agentic feed Report type
     */
    report_type: models.AiAgenticFeedReportType;

}
